<template>
	<div class="d-flex justify-center" v-if="isLoading">
		<v-progress-circular></v-progress-circular>
	</div>

	<v-container v-else class="login-page">
		<v-col class="login-column" :class="{ 'margin-bottom': $vuetify.breakpoint.mdAndUp }">
			<h1 class="login-page__title">Login</h1>
			<span class="mb-4 d-inline-block login-page__terms">{{ authHelpMessage }}</span>
			<LoginForm
				:categorySettings="categorySettings"
				:additionalLoginSettings="additionalLoginSettings"
			/>
		</v-col>
	</v-container>
</template>

<script>
import LoginForm from '@/components/Forms/LoginForm'
import { mapActions, mapGetters } from 'vuex'

export default {
	name: 'LoginPage',
	data() {
		return {
			categorySettings: null,
			additionalLoginSettings: null,
		}
	},
	components: {
		LoginForm,
	},
	computed: {
		...mapGetters('settings', ['login']),
		...mapGetters('auth', ['UserLogInCategories', 'isLoading']),

		authHelpMessage() {
			const { auth_message: authCategoryMessage } = this.categorySettings || {}
			return authCategoryMessage || 'Use your Clowder® credentials to log in'
		},
	},
	async created() {
		await this.getLogInCategory()
		const urlParams = new URLSearchParams(window.location.search)
		const slug = urlParams.get('slug')
		const foundCategory = this.UserLogInCategories.find((cat) => cat.slug === slug)
		this.categorySettings = foundCategory.login_settings
		this.additionalLoginSettings = foundCategory.additional_settings
	},
	methods: {
		...mapActions('auth', ['getLogInCategory']),
	},
}
</script>

<style lang="scss">
.container.login-page {
	margin-bottom: 70px;
	@media (max-width: 800px) {
		display: flex;
		justify-content: center;
		margin: 0;
	}
}

.login-column {
	max-width: 320px;
	height: 473px;
}

@media (min-width: 960px) {
	.login-column {
		width: 41.67%;
		margin-left: 10%;
	}

	.login-column.margin-bottom {
		margin-bottom: 1rem;
	}
}

.login-page {
	&__title {
		color: rgb(74, 74, 74);
		font-size: 36px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
	}

	&__terms {
		color: rgba(0, 0, 0, 0.6);
		font-weight: 400;
	}
}

.left-section {
	background-color: var(--splash-screen-background);
}
</style>
